import { render } from "./LegalTextsComponent.vue?vue&type=template&id=45a64c2b"
import script from "./LegalTextsComponent.vue?vue&type=script&lang=js"
export * from "./LegalTextsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__